import { WSAlert } from "@wingspanhq/fe-component-library";
import {
  IWorkLog,
  InvoiceStatus,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useHistory } from "react-router-dom";
import { useQueryInvoice } from "../../../query/payments/queries";

type Props = {
  workLog: IWorkLog | undefined;
};

export const AlertWorkLogInvoiceStatusPayee: React.FC<Props> = ({
  workLog
}) => {
  const history = useHistory();
  const invoiceId = workLog?.invoiceId;
  const isApproved = workLog?.status === WorkLogStatus.Approved;

  const queryInvoice = useQueryInvoice(invoiceId!, {
    enabled: !!invoiceId && isApproved
  });

  const isInvoiceDraft = queryInvoice.data?.status === InvoiceStatus.Draft;

  if (!isApproved || !invoiceId || !isInvoiceDraft) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      title="Action required"
      action={{
        text: "View invoice",
        onClick: () => history.push(`/member/invoices/${invoiceId}`)
      }}
    >
      When you created this work log, an invoice was automatically created in
      draft. Send it now so your client can review and approve payment, or
      cancel it if it's no longer needed.
    </WSAlert>
  );
};
